import { TFunction } from "react-i18next";
import { ItemInfo } from "./components/Menu";

export const getAdminMenuItems = (t: TFunction<"admin"[]>): ItemInfo[] => {
  return [{
    items: {
      '': {
        title: t('admin:menu.control-panel'),
        href: '/app/admin/',
      },
      'usuarios': {
        title: t('admin:menu.users'),
        href: '/app/admin/users',
        withRole: 'ROLE_ADMIN',
      },
      'translations': {
        title: t('admin:menu.translations'),
        href: '/app/admin/translations',
        withRole: 'ROLE_ADMIN',
        nested: {
          'translations': {
            title: t('admin:menu.translations'),
            href: '/app/admin/translations',
          },
          'observations': {
            title: t('admin:menu.observations'),
            href: '/app/admin/observations',
          },
          'export-comment': {
            title: t('admin:menu.export-comments'),
            href: '/app/admin/export-comments',
          },
          'sanitary-systems': {
            title: t('admin:menu.sanitary-systems'),
            href: '/app/admin/translations/static',
          },
        }
      },
      'indicadores': {
        title: t('admin:menu.indicators'),
        href: '/app/admin/indicators',
        withRole: 'ROLE_ADMIN',
        nested: {
          'sources': {
            title: t('admin:menu.sources'),
            href: '/app/admin/sources',
          },
          'domains': {
            title: t('admin:menu.domains'),
            href: '/app/admin/domains',
          },
          'units': {
            title: t('admin:menu.units'),
            href: '/app/admin/units',
          },
          'variable-states': {
            title: t('admin:menu.variable-states'),
            href: '/app/admin/variable-states',
          },
          'indicadores': {
            title: t('admin:menu.indicators'),
            href: '/app/admin/indicators',
          },
        }
      },
      'volcado-de-datos': {
        title: t('admin:menu.dumps'),
        href: '/app/admin/dumps',
        withRole: 'ROLE_ADMIN',
      },
      'third-party-data': {
        title: t('admin:menu.third-party'),
        href: '/app/admin/data',
        withRole: 'ROLE_EXPLORER',
        nested: {
          'indicadores': {
            title: t('admin:menu.third-party-export'),
            href: '/app/admin/data',
            withRole: 'ROLE_ADMIN',
          },
          'third-party-explorer': {
            title: t('admin:menu.third-party-explorer'),
            href: '/app/admin/data/explorer',
            withRole: 'ROLE_EXPLORER',
          },
        },
      },
    },
  }];
};
